module.exports = {
      id: "arrow-right-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }